import { useContext } from "react";
import { HiOutlinePencilAlt } from "react-icons/hi";

import { AccountFragment } from "graphql/fragments";
import { useFormatter } from "hooks";
import { PopupContext } from "providers/PopupHandler";
import { tw } from "utils/tw";

interface Props {
  account: AccountFragment;
  heading: string;
  description: string;
}

export default ({
  account,
  heading,
  description,
}: Props): React.JSX.Element => {
  const { getFormattedAddress } = useFormatter();
  const { openPopup } = useContext(PopupContext);

  return (
    <div>
      <div className={tw("space-y-6")}>
        <div className={tw("space-y-2")}>
          <div className={tw("flex", "justify-between")}>
            <h2 className={tw("text-lg", "font-bold")}>{heading}</h2>

            {account.canManage && (
              <button onClick={() => openPopup({ id: "AccountAddress" })}>
                <HiOutlinePencilAlt />
              </button>
            )}
          </div>

          <p className={tw("text-sm", "text-deepBlue-500")}>{description}</p>
        </div>

        <p className={tw("text-sm", "text-deepBlue-500")}>
          {account.address && getFormattedAddress(account.address)}
        </p>
      </div>
    </div>
  );
};
